import { createClient } from '@supabase/supabase-js';
import { config } from './config';

// Check required environment variables without exposing them
if (!config.supabaseUrl || !config.supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Configure Supabase with improved auth settings
export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,  // Prevent refresh loops
    storage: {
      // Use localStorage instead of sessionStorage for persistent sessions
      getItem: (key) => localStorage.getItem(key),
      setItem: (key, value) => localStorage.setItem(key, value),
      removeItem: (key) => localStorage.removeItem(key)
    }
  }
});